/**
 * @generated SignedSource<<1199dd91c52f8206370378744ff676d9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articlePrintHeadlineMessageArticle$data = {
  readonly printHeadline: string | null;
  readonly " $fragmentType": "articlePrintHeadlineMessageArticle";
};
export type articlePrintHeadlineMessageArticle$key = {
  readonly " $data"?: articlePrintHeadlineMessageArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articlePrintHeadlineMessageArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articlePrintHeadlineMessageArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "printHeadline",
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "cb944b1577351d00c33f13dab41eb87f";

export default node;
